import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Chris Litherland
 * id 362BCE24-8F91-491A-8EE8-BD08C296511A
 * name desktop-tower
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/desktop-tower.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const DesktopTowerIcon = createSvgIcon(<><path d="M8,2H16A2,2 0 0,1 18,4V20A2,2 0 0,1 16,22H8A2,2 0 0,1 6,20V4A2,2 0 0,1 8,2M8,4V6H16V4H8M16,8H8V10H16V8M16,18H14V20H16V18Z" /></>, 'DesktopTowerIcon');
export default DesktopTowerIcon